import api from "../../../utils/api";

// Get Client list
export const fetchClientsApi = async () => {
  const res = await api.get("/clients");
  return res.data;
};

// Get single client
export const fetchClientByIdApi = async (id) => {
  const res = await api.get(`/clients/${id}`);
  return res.data;
};

// Create client
export const createClientApi = async (payload) => {
  const res = await api.post("/clients", payload);
  return res.data;
};

// Update client
export const updateClientApi = async (id, payload) => {
  const res = await api.put(`/clients/${id}`, payload);
  return res.data;
};

// Delete client
export const deleteClientApi = async (id) => {
  const res = await api.delete(`/clients/${id}`);
  return res.data;
};